<template>
    <div>
        <div>为了保证您的帐号安全，更换密码前请先进行安全验证</div>
        <div class="mt10">您当前的安全手机是：{{mobileFormat}}</div>
        <sms class="mt20" :mobile="mobile" v-model="smsCode"></sms>
        <el-button class="pct100 mt20" type="primary" @click="next()" :disabled="!smsCode" :loading="isLoading">下一步</el-button>
    </div>
</template>
<script>
import sms from './components/smsCode'
export default {
    data() {
            return {
                mobile: parseInt(this.memberSecurityInfo.bindTel),
                smsCode: '',
                isLoading: false,
            }
        },
        components: {
            sms
        },
        computed: {
            mobileFormat() {
                return this.mobile.toString().replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')
            },
        },
        props: ['memberSecurityInfo'],
        methods: {
            next() {
                this.isLoading = true
                let params = {
                    info: {
                        custTel: this.mobile,
                        smsCode: this.smsCode
                    }
                }
                $.post(__consoleURL + '/api-portal/api/register/smsCodeCheck', {
                    data: JSON.stringify(params)
                }).then(response => {
                    console.log(response)
                    if(!response){
                        this.$emit('next')
                    }else{
                        this.$message({
                            type: 'error',
                            message: response.msg
                        })
                        this.isLoading = false
                    }
                },(err => {
                    this.isLoading = false
                }))
            }
        }

}
</script>



// WEBPACK FOOTER //
// src/Payment/components/dialog-verifyMobile.vue